import { ServicesForm } from '../../../features/services/ServiceForm';

export const ServicesPage = ({ isNew }: { isNew: boolean }) => {
  return (
    <div>
      <ServicesForm isNew={isNew} />
    </div>
  );
};
